import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { 
    fetchMarketOtherTopics, 
    createMarketOtherTopic, 
    deleteMarketOtherTopic 
} from '../../../../store/startup/market/marketSlice';
import {
    Box,
    Divider,
    Grid,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TextField,
    Typography,
    Modal,
    Paper,
    Grid2
} from '@mui/material';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import Button from '@mui/material/Button';
import UploadFileIcon from '@mui/icons-material/UploadFile';
import DeleteIcon from '@mui/icons-material/Delete';
import { Add } from '@mui/icons-material';
import SingleFileUpload from '../../../fileUpload/FileUpload';
import { CircularProgress } from '@mui/material';
import { Alert } from '@mui/material';
import { toast } from 'react-toastify';

const OtherTopics = () => {
    const dispatch = useDispatch();
    const { startupId } = useParams();
    const { otherTopics = [], loading, error } = useSelector(state => state.market);
    const [open, setOpen] = useState(false);
    const [newTopic, setNewTopic] = useState({
        topic: '',
        description: ''
    });

    useEffect(() => {
        dispatch(fetchMarketOtherTopics(startupId));
    }, [dispatch, startupId]);

    const handleOpen = () => setOpen(true);
    const handleClose = () => {
        setOpen(false);
        setNewTopic({ topic: '', description: '' });
    };

    const handleSave = async () => {
        if (!newTopic.topic || !newTopic.description) {
            toast.error('Lütfen tüm alanları doldurun');
            return;
        }

        try {
            await dispatch(createMarketOtherTopic({
                startupId,
                ...newTopic
            })).unwrap();
            dispatch(fetchMarketOtherTopics(startupId));
            handleClose();
        } catch (error) {
            console.error('Failed to create topic:', error);
        }
    };

    const handleDelete = async (additionalTopicId) => {
        try {
            await dispatch(deleteMarketOtherTopic(additionalTopicId)).unwrap();
            dispatch(fetchMarketOtherTopics(startupId));
        } catch (error) {
            console.error('Failed to delete topic:', error);
        }
    };

    if (loading) {
        return <CircularProgress />;
    }

    if (error) {
        return <Alert severity="error">{error}</Alert>;
    }

    return (
        <div>
            <Box sx={{ display: 'flex', width: '100%' }}>
                <Box sx={{ flexGrow: 1, width: '80%' }}>
                    <Typography variant="h5" sx={{ mb: 2 }}>
                    Ürün/Proje ile İlgili Belirtmek İstediğiniz Diğer Konular
                    </Typography>
                </Box>
                <Box sx={{ display: 'flex', alignItems: 'right', justifyContent: 'right', width: '20%', height: '1%' }}>
                    <Button 
                        variant="outlined" 
                        size="small" 
                        color="primary" 
                        startIcon={<Add />} 
                        onClick={handleOpen}
                    >
                        Yeni Ekle
                    </Button>
                </Box>
                <Divider sx={{ marginBottom: 3 }} />
            </Box>

            <TableContainer component={Paper} sx={{ marginBottom: 1 }}>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell>Konu</TableCell>
                            <TableCell>Açıklama</TableCell>
                            <TableCell></TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {otherTopics?.map((topic) => (
                            <TableRow key={topic.additionalTopicId}>
                                <TableCell>{topic.topic || ''}</TableCell>
                                <TableCell>{topic.description || ''}</TableCell>
                                <TableCell align="right">
                                    <Button 
                                        size='small' 
                                        color="error" 
                                        startIcon={<DeleteIcon />}
                                        onClick={() => handleDelete(topic.additionalTopicId)}
                                    />
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>

            {/* Modal */}
            <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby="modal-title"
                aria-describedby="modal-description"
                sx={{ width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}
            >
                <Box sx={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    width: 800,
                    bgcolor: 'background.paper',
                    boxShadow: 24,
                    p: 4,
                    borderRadius: 1,
                }}>
                    <Typography id="modal-title" variant="h6" sx={{ mb: 2 }}>
                        Yeni Konu Ekle
                    </Typography>

                    <Grid2 container spacing={2}>
                        <Grid2 xs={12} sm={8}>
                            <TextField 
                                label="Konu" 
                                fullWidth 
                                value={newTopic.topic}
                                onChange={(e) => setNewTopic({...newTopic, topic: e.target.value})}
                                sx={{ mb: 2 }}
                            />
                            <TextField 
                                label="Açıklama" 
                                fullWidth 
                                multiline 
                                rows={4} 
                                value={newTopic.description}
                                onChange={(e) => setNewTopic({...newTopic, description: e.target.value})}
                            />
                        </Grid2>
                    </Grid2>

                    <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 3 }}>
                        <Button variant="outlined" color="error" onClick={handleClose}>
                            İptal
                        </Button>
                        <Button 
                            variant="contained" 
                            color="primary" 
                            onClick={handleSave}
                            disabled={!newTopic.topic || !newTopic.description}
                        >
                            Kaydet
                        </Button>
                    </Box>
                </Box>
            </Modal>
            <Divider sx={{ marginBottom: 4, marginTop: 4 }} />
        </div>
    );
};

export default OtherTopics;
